import { render, staticRenderFns } from "./landing-page.html?vue&type=template&id=56d8afe4&scoped=true&"
import script from "./landing-page.js?vue&type=script&lang=js&"
export * from "./landing-page.js?vue&type=script&lang=js&"
import style0 from "./landing-page.css?vue&type=style&index=0&id=56d8afe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8afe4",
  null
  
)

export default component.exports